import React, {useCallback} from 'react'
import styled from '@emotion/styled'
import {Color} from '../Styles'
import {FlexContainer} from './Containers'
import {MemberMagnifyingGlassIcon} from './Icons/MemberMagnifyingGlassIcon'

type MBSecondaryMiniBaseButtonProps = {
  label: string
  onClick: () => void
  testId?: string
}
const StyledSecondaryMiniBaseButton = styled.button`
  padding: 4px 8px 4px 8px;
  box-sizing: border-box;
  font-size: 1.3rem;
  color: ${Color.Grey800};
  background: ${Color.White};
  border: solid 1px ${Color.Grey100};
  border-radius: 3px;
  box-shadow: 0 2px 3px 0 rgb(0 0 0 / 5%);
  @media (min-width: 769px) {
    &:focus {
      opacity: 0.6;
    }
    &:hover {
      opacity: 0.6;
    }
  }
`
const MBSecondaryMiniBaseButton: React.VFC<MBSecondaryMiniBaseButtonProps> = (props) => {
  const handleClick = useCallback((e: React.MouseEvent): void => {
    const eventTarget = e.target as HTMLElement
    eventTarget.blur()
    props.onClick()
  }, [props.onClick])

  return (
    <StyledSecondaryMiniBaseButton
      data-testid={props.testId}
      onClick={(e): void => {handleClick(e)}}>
      {props.label}
    </StyledSecondaryMiniBaseButton>
  )
}

export type MBDeleteButtonProps = Pick<MBSecondaryMiniBaseButtonProps, 'onClick' | 'testId'>
export const MBDeleteButton: React.VFC<MBDeleteButtonProps> = (props) => {
  return (<MBSecondaryMiniBaseButton testId={props.testId} label={'削除'} onClick={props.onClick}/>)
}

const StyledExternalLinkButton = styled.a`
  cursor: pointer;
  font-size: 1.4rem;
  display: inline-block;
  text-decoration: none;
  width: 100%;
  max-width: 305px;
  padding: 14px 5px 13px;
  text-align: center;
  vertical-align: middle;
  color: ${Color.Grey800};
  border: solid 1px ${Color.Grey100};
  border-radius: 6px;
  background: ${Color.White};
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, .05);
  @media (min-width: 769px) {
    &:hover {
      opacity: 0.6;
    }
  }
`

export type ExternalLinkButtonProps = {
  label: string
  url?: string
}
export const ExternalLinkButton: React.VFC<ExternalLinkButtonProps> = (props) => {
  return <StyledExternalLinkButton href={props.url}>{props.label}</StyledExternalLinkButton>
}

type LinkButtonProps = {
  fontSize?: number
  lineHeight?: number
  color?: string
}
export const LinkButton = styled.a`
  font-size: ${({fontSize}: LinkButtonProps): number => fontSize ?? 1.3}rem;
  color: ${({color}: LinkButtonProps): string => color ?? Color.Grey800};
  line-height: ${({lineHeight}: LinkButtonProps): number => lineHeight ?? 1.8}rem;
  display: inline-block;
  text-decoration-line: underline;
  cursor: pointer;
  @media (min-width: 769px) {
    &:hover {
      opacity: 0.6;
    }
  }
`

type MBSearchButtonProps = {
  testId?: string
  label: string
  onClick: () => void
}
const StyledSearchButton = styled.button`
  margin-top: 0 !important;
  padding: 6px 23px 5px 14px;
  box-sizing: border-box;
  font-size: 1.3rem;
  color: ${Color.Grey800};
  background: ${Color.White};
  border: solid 1px ${Color.Grey100};
  border-radius: 3px;
  box-shadow: 0 2px 3px 0 rgb(0 0 0 / 5%);
  @media (min-width: 769px) {
    &:focus {
      opacity: 0.6;
    }
    &:hover {
      opacity: 0.6;
    }
  }
`
const MBSearchButton: React.VFC<MBSearchButtonProps> = (props) => {
  return (
    <StyledSearchButton
      data-testid={props.testId ?? 'mb-search-button'}
      onClick={props.onClick}
    >
      <FlexContainer alignItems={'center'} justifyContent={'center'} gap={'9px'}>
        <MemberMagnifyingGlassIcon/>
        {props.label}
      </FlexContainer>
    </StyledSearchButton>
  )
}

export type MBAddressSearchButtonProps = Pick<MBSearchButtonProps, 'onClick'>
export const MBAddressSearchButton: React.VFC<MBAddressSearchButtonProps> = (props) => {
  return (
    <MBSearchButton
      testId={'mb-address-search-button'}
      label={'住所検索'}
      onClick={props.onClick}
    />
  )
}
